import { c as _c } from "react-compiler-runtime";
import { forwardRef, useEffect, useMemo } from 'react';
import { registerCustomFunction, unregisterCustomFunction } from 'nudge-client-utils';
import { UI_MODE } from 'framework-listing-lib/constants';
import { useEventCallback } from 'framework-listing-lib/internal/hooks/useEventCallback';
import { PropertiesProvider as CustomerDataPropertiesProvider } from 'customer-data-properties/context';
import UserInfoProvider from 'marketing-platform-lib/providers/UserInfoProvider';
import AsyncListingLibDevTools from 'framework-listing-lib/internal/DevTools/components/AsyncListingLibDevTools';
import useOpenDevTools from 'framework-listing-lib/internal/DevTools/hooks/useOpenDevTools';
import ErrorBoundary from 'framework-listing-lib/internal/ErrorBoundary';
import CurrentViewProvider from 'framework-listing-lib/internal/ViewTabs/providers/CurrentViewProvider';
import { PinnedViewsBarClientProvider } from 'framework-listing-lib/internal/ViewTabs/providers/PinnedViewsBarClientProvider';
import ViewsProvider from 'framework-listing-lib/internal/ViewTabs/providers/ViewsProvider';
import usePerformanceTracking from 'framework-listing-lib/internal/hooks/usePerformanceTracking';
import CrmObjectTypeListingClientProvider from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';
import DataProvider from 'framework-listing-lib/internal/providers/DataProvider';
import ListingProvider from 'framework-listing-lib/internal/providers/ListingProvider';
import PropertiesProvider from 'framework-listing-lib/internal/providers/PropertiesProvider';
import TrackerProvider from 'framework-listing-lib/internal/providers/TrackerProvider';
import { MEASURE_MARK_NAMES } from 'framework-listing-lib/internal/utils/performanceTracking';
import { SENTRY_KEYS } from 'framework-listing-lib/utils/sentry';
import { DataWellSlotProvider } from 'framework-listing-lib/internal/providers/DataWellSlotProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FOLDERS_MODE_BUTTON_KEY = 'framework-listing-lib:click-folders-mode-button';
function FrameworkListingLibProvider(t0) {
  "use memo";

  var _uiModeProps$onChange;
  const $ = _c(50);
  const {
    associationSpecs,
    calendarProps,
    children,
    emptyStateFilter,
    enableFieldLevelPermissions: t1,
    enableObjectLevelPermissions: t2,
    fetcher,
    fetcherKey,
    folderProps,
    hiddenFilter,
    initialFilter,
    inlineEditProps,
    objectType,
    propertyOverride,
    typeDefinitionOverride,
    quickFilterProps,
    searchInputProps: _searchInputProps,
    trackerProps,
    uiModeProps,
    viewProps,
    showHighlySensitiveProperties,
    skipCrm,
    sortPropertyOverride,
    _useNonGqlCRMSearch
  } = t0;
  const enableFieldLevelPermissions = t1 === undefined ? false : t1;
  const enableObjectLevelPermissions = t2 === undefined ? false : t2;
  const [open] = useOpenDevTools();
  usePerformanceTracking(MEASURE_MARK_NAMES.LIFECYCLE);
  const onChangeUIMode = useEventCallback((_uiModeProps$onChange = uiModeProps === null || uiModeProps === void 0 ? void 0 : uiModeProps.onChangeUIMode) !== null && _uiModeProps$onChange !== void 0 ? _uiModeProps$onChange : _temp);
  let t3;
  if ($[0] !== onChangeUIMode) {
    t3 = () => {
      let timeoutId;
      registerCustomFunction(FOLDERS_MODE_BUTTON_KEY, () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          onChangeUIMode(UI_MODE.FOLDERS);
        }, 0);
      });
      return () => {
        unregisterCustomFunction(FOLDERS_MODE_BUTTON_KEY);
        clearTimeout(timeoutId);
      };
    };
    $[0] = onChangeUIMode;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = uiModeProps === null || uiModeProps === void 0 ? void 0 : uiModeProps.onChangeUIMode;
  let t5;
  if ($[2] !== onChangeUIMode || $[3] !== t4) {
    t5 = [t4, onChangeUIMode];
    $[2] = onChangeUIMode;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  useEffect(t3, t5);
  let t6;
  bb0: {
    if (_searchInputProps) {
      const t7 = typeof _searchInputProps.hasSearchInput === "boolean" ? _searchInputProps.hasSearchInput : true;
      let t8;
      if ($[5] !== _searchInputProps || $[6] !== t7) {
        t8 = Object.assign({}, _searchInputProps, {
          hasSearchInput: t7
        });
        $[5] = _searchInputProps;
        $[6] = t7;
        $[7] = t8;
      } else {
        t8 = $[7];
      }
      t6 = t8;
      break bb0;
    }
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        hasSearchInput: true
      };
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    t6 = t7;
  }
  const searchInputProps = t6;
  const t7 = uiModeProps ? uiModeProps.onChangeUIMode : undefined;
  let t8;
  if ($[9] !== open) {
    t8 = open && /*#__PURE__*/_jsx(AsyncListingLibDevTools, {});
    $[9] = open;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== children || $[12] !== t7 || $[13] !== t8) {
    t9 = /*#__PURE__*/_jsxs(ViewsProvider, {
      onChangeUIMode: t7,
      children: [t8, children]
    });
    $[11] = children;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== associationSpecs || $[16] !== calendarProps || $[17] !== emptyStateFilter || $[18] !== fetcher || $[19] !== fetcherKey || $[20] !== folderProps || $[21] !== hiddenFilter || $[22] !== initialFilter || $[23] !== inlineEditProps || $[24] !== quickFilterProps || $[25] !== searchInputProps || $[26] !== t9) {
    t10 = /*#__PURE__*/_jsx(CurrentViewProvider, {
      children: /*#__PURE__*/_jsx(DataWellSlotProvider, {
        children: /*#__PURE__*/_jsx(CrmObjectTypeListingClientProvider, {
          associationSpecs: associationSpecs,
          calendarProps: calendarProps,
          emptyStateFilter: emptyStateFilter,
          fetcher: fetcher,
          fetcherKey: fetcherKey,
          folderProps: folderProps,
          hiddenFilter: hiddenFilter,
          initialFilter: initialFilter,
          inlineEditProps: inlineEditProps,
          quickFilterProps: quickFilterProps,
          searchInputProps: searchInputProps,
          children: t9
        })
      })
    });
    $[15] = associationSpecs;
    $[16] = calendarProps;
    $[17] = emptyStateFilter;
    $[18] = fetcher;
    $[19] = fetcherKey;
    $[20] = folderProps;
    $[21] = hiddenFilter;
    $[22] = initialFilter;
    $[23] = inlineEditProps;
    $[24] = quickFilterProps;
    $[25] = searchInputProps;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== showHighlySensitiveProperties || $[29] !== t10) {
    t11 = /*#__PURE__*/_jsx(DataProvider, {
      showHighlySensitiveProperties: showHighlySensitiveProperties,
      children: t10
    });
    $[28] = showHighlySensitiveProperties;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== propertyOverride || $[32] !== sortPropertyOverride || $[33] !== t11 || $[34] !== typeDefinitionOverride) {
    t12 = /*#__PURE__*/_jsx(PropertiesProvider, {
      propertyOverride: propertyOverride,
      sortPropertyOverride: sortPropertyOverride,
      typeDefinitionOverride: typeDefinitionOverride,
      children: t11
    });
    $[31] = propertyOverride;
    $[32] = sortPropertyOverride;
    $[33] = t11;
    $[34] = typeDefinitionOverride;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== _useNonGqlCRMSearch || $[37] !== enableObjectLevelPermissions || $[38] !== objectType || $[39] !== skipCrm || $[40] !== t12 || $[41] !== uiModeProps || $[42] !== viewProps) {
    t13 = /*#__PURE__*/_jsx(PinnedViewsBarClientProvider, {
      children: /*#__PURE__*/_jsx(ListingProvider, {
        enableObjectLevelPermissions: enableObjectLevelPermissions,
        objectType: objectType,
        uiModeProps: uiModeProps,
        viewProps: viewProps,
        skipCrm: skipCrm,
        _useNonGqlCRMSearch: _useNonGqlCRMSearch,
        children: t12
      })
    });
    $[36] = _useNonGqlCRMSearch;
    $[37] = enableObjectLevelPermissions;
    $[38] = objectType;
    $[39] = skipCrm;
    $[40] = t12;
    $[41] = uiModeProps;
    $[42] = viewProps;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== enableFieldLevelPermissions || $[45] !== t13) {
    t14 = /*#__PURE__*/_jsx(CustomerDataPropertiesProvider, {
      enableFieldLevelPermissions: enableFieldLevelPermissions,
      children: t13
    });
    $[44] = enableFieldLevelPermissions;
    $[45] = t13;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  let t15;
  if ($[47] !== t14 || $[48] !== trackerProps) {
    t15 = /*#__PURE__*/_jsx(ErrorBoundary, {
      fingerprint: SENTRY_KEYS.TOP_LEVEL_LIB_PROVIDER,
      children: /*#__PURE__*/_jsx(UserInfoProvider, {
        children: /*#__PURE__*/_jsx(TrackerProvider, Object.assign({}, trackerProps, {
          children: t14
        }))
      })
    });
    $[47] = t14;
    $[48] = trackerProps;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  return t15;
}
function _temp() {}
export default $hasDep('react-dnd', '5') ? FrameworkListingLibProvider :
// eslint-disable-next-line @typescript-eslint/no-var-requires
require('customer-data-ui-utilities/dnd/SharedDragDropContext').default()( /*#__PURE__*/forwardRef((props, __ref) => {
  "use memo";

  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = /*#__PURE__*/_jsx(FrameworkListingLibProvider, Object.assign({}, props));
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}));